import { render, staticRenderFns } from "./StateroomDetailSuite.vue?vue&type=template&id=b68c414e&scoped=true"
import script from "./StateroomDetailSuite.vue?vue&type=script&lang=js"
export * from "./StateroomDetailSuite.vue?vue&type=script&lang=js"
import style0 from "./StateroomDetailSuite.vue?vue&type=style&index=0&id=b68c414e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b68c414e",
  null
  
)

export default component.exports